import { get } from 'lodash'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import CatalogAppInstanceForm from '@/components/CatalogAppInstanceForm'
import { CatalogAppInstance, SpaceCatalogAppDetailsProps } from '@/pages/SpaceCatalogAppDetailsPage/interfaces'

import messages from './messages'

export type SpaceCatalogAppDetailsEditProps = SpaceCatalogAppDetailsProps<CatalogAppInstance>

const SpaceCatalogAppDetailsEdit = ({
  app = {} as CatalogAppInstance,
  deleteApp,
  goBack = () => null,
  goToConnectorLogs = () => null,
  installApp,
  isDeleteActionInProgress,
  isUpdateActionInProgress,
  updateApp
}: SpaceCatalogAppDetailsEditProps) => {
  const iconUrl = app ? app.iconUrl : ''
  const [getActionMessage] = useState(() => {
    if (isDeleteActionInProgress) {
      return <FormattedMessage {...messages.deleting} />
    } else if (isUpdateActionInProgress) {
      return <FormattedMessage {...messages.saving} />
    }
  })
  return (
    <CatalogAppInstanceForm
      actionMessage={getActionMessage}
      onDelete={deleteApp}
      isActionInProgress={isDeleteActionInProgress || isUpdateActionInProgress}
      app={app}
      appNameOverride={app.overrideAppName || ''}
      appImageUrlOverride={app.overrideAppIconUrl || iconUrl}
      isUpdateMode={true}
      onInstall={installApp}
      goBack={goBack}
      goToConnectorLogs={goToConnectorLogs}
      onUpdate={updateApp}
      webHookUrl={get(app.connectorConfig, 'webHookUrl', '')}
    />
  )
}

SpaceCatalogAppDetailsEdit.displayName = 'SpaceCatalogAppDetailsEdit'

export default SpaceCatalogAppDetailsEdit
